// automatically generated by the FlatBuffers compiler, do not modify
// @ts-nocheck
import { flatbuffers } from "flatbuffers";

export class Float64FBArray {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Float64FBArray {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFloat64FBArray(
    bb: flatbuffers.ByteBuffer,
    obj?: Float64FBArray
  ): Float64FBArray {
    return (obj || new Float64FBArray()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb
    );
  }

  static getSizePrefixedRootAsFloat64FBArray(
    bb: flatbuffers.ByteBuffer,
    obj?: Float64FBArray
  ): Float64FBArray {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Float64FBArray()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb
    );
  }

  data(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? this.bb!.readFloat64(
          this.bb!.__vector(this.bb_pos + offset) + index * 8
        )
      : 0;
  }

  dataLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  dataArray(): Float64Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? new Float64Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset)
        )
      : null;
  }

  static startFloat64FBArray(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addData(builder: flatbuffers.Builder, dataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, dataOffset, 0);
  }

  static createDataVector(
    builder: flatbuffers.Builder,
    data: number[] | Float64Array
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createDataVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array
  ): flatbuffers.Offset;
  static createDataVector(
    builder: flatbuffers.Builder,
    data: number[] | Float64Array | Uint8Array
  ): flatbuffers.Offset {
    builder.startVector(8, data.length, 8);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addFloat64(data[i]!);
    }
    return builder.endVector();
  }

  static startDataVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 8);
  }

  static endFloat64FBArray(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createFloat64FBArray(
    builder: flatbuffers.Builder,
    dataOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    Float64FBArray.startFloat64FBArray(builder);
    Float64FBArray.addData(builder, dataOffset);
    return Float64FBArray.endFloat64FBArray(builder);
  }
}
